module.exports = __webpack_public_path__ + "client/styles/fonts/Roboto-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/Roboto-Medium.ttf
// module id = 1480
// module chunks = 0